export default {
	type: 'object',
	properties: {
		projectId: { type: 'string' },
		projectUrl: { type: 'string' },
	},
	required: ['projectId', 'projectUrl'],
	additionalProperties: false,
}
